import React from "react"
import { Navbar, Nav } from "react-bootstrap"
import { Link } from "react-router-dom"

export default function NavbarComponent() {
  return (
    <Navbar  expand="sm" style={{boxShadow: "5px 5px 5px lightgrey", backgroundColor: "#1B426E"}} >
      <Navbar.Brand as={Link} to="/">
      <img src="https://www.czechmtm.cz/logo-drive-white.png" alt="mtm-drive" width="290" height="auto"></img>
      </Navbar.Brand>
      <Nav>
        <Nav.Link as={Link} to="/user" style={{color: "white"}}>
          Odhlásit
        </Nav.Link>
      </Nav>
    </Navbar>
    
  )
}
